import * as React from 'react'

import * as Style from './style.css'

export type IProps = React.ComponentPropsWithoutRef<'img'>

export const PersonIcon = (props: IProps): JSX.Element => (
  <img
    src="/img/prof_icon/i_child_count.png"
    className={Style.Icon}
    {...props}
  />
)

export default PersonIcon
